<mat-accordion multi class="activity-accordion" data-testid="activity-tab-container">
    <div fxLayout fxLayoutAlign="end">
        <button
            mat-raised-button
            color="primary"
            class="m-a-sm"
            (click)="toggleAll()"
            [disabled]="!currentDocument().activityInstances?.length"
            data-testid="activity-tab-expand-all">
            @let all_expanded = allExpanded();
            {{ "actions." + (all_expanded ? "collapseAll" : "expandAll") | translate }}
            <mat-icon iconPositionEnd>{{ all_expanded ? "expand_less" : "expand_more" }}</mat-icon>
        </button>
    </div>
    @if (currentDocument().activityInstances) {
        @for (
            activityInstance of currentDocument().activityInstances;
            track activityInstance.instance.actionInstanceId
        ) {
            @let activity = activityInstance.instance;
            @let activityDetails = activityInstance.activityDetails;
            <!-- Expand the activity from url query params -->
            <mat-expansion-panel
                #expansionPanel
                [expanded]="activity.actionInstanceId === expandedActivityId()"
                (opened)="loadActivityData(activity.actionInstanceId)"
                (closed)="onPanelClose()"
                (expandedChange)="checkAllExpanded()"
                [attr.data-testid]="'activity-tab-item-' + activity.actionInstanceId">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <div class="cipo--width--full" fxLayout>
                            <div class="activity-summary">
                                <div class="activity-author" fxLayout fxLayoutGap="20px" fxLayoutAlign="start center">
                                    @if (activity.logo) {
                                        <cipo-img-base64
                                            [base64]="activity.logo"
                                            [height]="50"
                                            radius="50%"
                                            data-testid="activity-tab-item-logo" />
                                    } @else {
                                        <div class="cipo--avatar" data-testid="activity-tab-item-no-logo">
                                            <p class="cipo--text--uppercase">
                                                {{ activity.user ? activity.user[0] : "@" }}
                                            </p>
                                        </div>
                                    }
                                    <div>
                                        <p class="cipo-text--medium-xl" data-testid="activity-tab-item-user">
                                            {{ activity.user || ("general.unknown" | translate) }}
                                        </p>
                                        <p data-testid="activity-tab-item-created-on">
                                            {{ activity.createdOn | itvDateTime }}
                                        </p>
                                    </div>
                                </div>
                                <div class="activity-details">
                                    <div class="activity-box" data-testid="activity-tab-item-action-name">
                                        <cipo-state
                                            customClass="p-x-sm"
                                            bgColor="#d4e1ec"
                                            [name]="activity.actionName" />
                                    </div>
                                    @if (activity.state && ACTIVITIES_WITH_STATE.includes(activity.type)) {
                                        <div class="activity-box activity-transition">
                                            <cipo-state
                                                class="activity-state"
                                                customClass="p-x-sm"
                                                [bgColor]="activity.stateColor"
                                                [name]="activity.state"
                                                [textColor]="activity.stateTextColor"
                                                data-testid="activity-tab-item-state" />
                                            @if (activity.nextState) {
                                                <mat-icon aria-hidden="true">arrow_right_alt</mat-icon>
                                                <cipo-state
                                                    class="activity-state"
                                                    customClass="p-x-sm"
                                                    [bgColor]="activity.nextStateColor"
                                                    [name]="activity.nextState"
                                                    [textColor]="activity.nextStateTextColor"
                                                    data-testid="activity-tab-item-next-state" />
                                            }
                                        </div>
                                    }
                                </div>
                            </div>
                            @if (expansionPanel.expanded && activityDetails) {
                                <div
                                    fxFlex="none"
                                    fxLayout
                                    fxLayout.lt-md="column"
                                    fxLayoutAlign="center center"
                                    tabindex="0"
                                    (click)="$event.stopPropagation()"
                                    (keydown)="$event.stopPropagation()">
                                    <!-- TODO: Check these props (should not be negative) -->
                                    @if (activityDetails.canUndoLastAction) {
                                        <button
                                            mat-icon-button
                                            color="primary"
                                            [disabled]="currentDocument().actionsDisabled"
                                            (click)="undoLastAction(activityDetails)"
                                            [attr.aria-label]="'actions.undoLastAction' | translate"
                                            data-testid="activity-tab-undo-last-action">
                                            <mat-icon aria-hidden="true">undo</mat-icon>
                                        </button>
                                    }
                                    @if (activityDetails.canExclude) {
                                        <button
                                            mat-icon-button
                                            color="accent"
                                            [disabled]="currentDocument().actionsDisabled"
                                            (click)="updateNotified(activityDetails)"
                                            [title]="'activity.excludeRoles' | translate"
                                            [attr.aria-label]="'activity.excludeRoles' | translate"
                                            data-testid="activity-tab-exclude-roles">
                                            <mat-icon aria-hidden="true">group_remove</mat-icon>
                                        </button>
                                    }
                                </div>
                            }
                        </div>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <!-- Content -->
                <cipo-activity-item-content [activityDetails]="activityDetails" />
            </mat-expansion-panel>
        }
    } @else {
        <div fxLayout fxLayoutAlign="center center" fxLayoutGap="20px">
            <div fxFlex="none">
                <ngx-skeleton-loader appearance="circle" [theme]="{ width: '50px', height: '50px' }" />
            </div>
            <div fxFlex="grow">
                <ngx-skeleton-loader count="2" [theme]="{ height: '16px', margin: '0' }" />
            </div>
        </div>
    }
</mat-accordion>
